<template>
    <i :title="$t(label)" :class="icon"></i>
</template>

<script>

const typeMapping = {
    'success': {
        label: "",
        icon: "fa fa-check-circle text-success"
    },
    'error': {
        label: "",
        icon: "fa fa-exclamation-triangle text-danger"
    },
    'running': {
        label: "",
        icon: "fa fa-circle-notch fa-spin text-primary"
    }
};

export default {
    name: "mmf-icon",
    props: {
        'type': String
    },
    data: function() {
        return {
            bType: this.type
        }
    },
    computed: {
        icon: function() {
            return typeMapping[this.bType].icon;
        },
        label: function() {
            return typeMapping[this.bType].label;
        }
    },
    methods: {
    }
}
</script>